.provisionRow {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
  flex-wrap: wrap;
}

.provisionWarning {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 13px;
  color: var(--yellow);
  font-weight: 500;
  width: 100%;
  margin-bottom: 4px;
}

.provisionBtn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  background: var(--blue);
  color: white;
  border: none;
  border-radius: 24px;
  font-size: 13.5px;
  font-weight: 600;
  font-family: 'Google Sans', sans-serif;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(26,115,232,.3);
  transition: background .15s, box-shadow .15s, transform .1s;
  white-space: nowrap;
}

.provisionBtn:hover:not(:disabled) {
  background: var(--blue-dk);
  box-shadow: 0 2px 6px rgba(26,115,232,.4);
  transform: translateY(-1px);
}

.provisionBtn:active:not(:disabled) { transform: translateY(0); }

.provisionBtn:disabled {
  opacity: .45;
  cursor: default;
}

.provisionSuccess {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13.5px;
  color: var(--green);
  font-weight: 500;
}

.provisionSuccess a {
  color: var(--green);
  text-decoration: underline;
  font-weight: 600;
}

.provisionConflict {
  display: flex;
  align-items: flex-start;
  gap: 5px;
  font-size: 13.5px;
  color: var(--yellow);
  font-weight: 500;
}

.provisionConflict a {
  color: var(--blue);
  text-decoration: underline;
  font-weight: 500;
}

.provisionError {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13.5px;
  color: var(--red);
  font-weight: 500;
}
